import { render } from "./AgendaCard.vue?vue&type=template&id=7353a6a7&scoped=true"
import script from "./AgendaCard.vue?vue&type=script&lang=js"
export * from "./AgendaCard.vue?vue&type=script&lang=js"

import "./AgendaCard.vue?vue&type=style&index=0&id=7353a6a7&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7353a6a7"]])

export default __exports__